<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormMaterial" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objMaterial.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objMaterial.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>

                    <div class="row form-group">
                        <h6>Configuración de Dioptrías</h6>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="objMaterial.ReqDioptria" class="form-check-input" role="switch" type="checkbox" id="ReqDioptria">
                                <label class="form-check-label" for="ReqDioptria">Mostrar precio de dioptrías</label>
                            </div>
                            <CValidation v-if="this.errorvalidacion.ReqDioptria" :Mensaje="'*'+errorvalidacion.ReqDioptria[0]"/>
                        </div>

                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="objMaterial.ReqDescuentoDiop" class="form-check-input" role="switch" type="checkbox" id="ReqDescuentoDiop">
                                <label class="form-check-label" for="ReqDescuentoDiop">Aplicar Descuento de Dioptrías</label>
                            </div>
                            <CValidation v-if="this.errorvalidacion.ReqDescuentoDiop" :Mensaje="'*'+errorvalidacion.ReqDescuentoDiop[0]"/>
                        </div>

                        <div v-if="objMaterial.ReqDescuentoDiop" class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-2">
                            <label class="form-label" for="TipoDescuento">Tipo de Descuento</label>
                            <select name="TipoDescuento" id="TipoDescuento" v-model="objMaterial.TipoDescuento" class="form-control form-select">
                                <option :value="0">Seleccione una opción</option>
                                <option :value="1">Descuento en porcentaje</option>
                                <option :value="2">Descuento en monto fijo</option>
                            </select>
                            <CValidation v-if="this.errorvalidacion.TipoDescuento" :Mensaje="'*'+errorvalidacion.TipoDescuento[0]"/>
                        </div>

                        <div v-if="objMaterial.ReqDescuentoDiop" class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-2">

                            <label v-if="parseInt(objMaterial.TipoDescuento) == 1" class="form-label" for="Descuento">% Descuento</label>
							<label v-else-if="parseInt(objMaterial.TipoDescuento) == 2" class="form-label" for="Descuento">Monto de descuento</label>
							<label v-else class="form-label" for="Descuento">Descuento</label>
                            
                            <input type="text" v-model="objMaterial.ValorDescuento" @input="$onlyNums($event,objMaterial,'ValorDescuento')" id="ValorDescuento" placeholder="Ingresar Descuento" class="form-control">
                            <CValidation v-if="this.errorvalidacion.ValorDescuento" :Mensaje="'*'+errorvalidacion.ValorDescuento[0]"/>
                        </div>

                    </div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormMaterial',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objMaterial: {
				IdMaterial: 0,
				Nombre: '',
				Clave: '',
				ReqDioptria: false,
                ReqDescuentoDiop: false,
                TipoDescuento: 0,
                ValorDescuento: 0,
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
            let materialCopy = this.objMaterial;
            materialCopy.ReqDioptria = this.objMaterial.ReqDioptria ===true ? 'SI' : 'NO';
            materialCopy.ReqDescuentoDiop = this.objMaterial.ReqDescuentoDiop   ===true ? 'SI' : 'NO';
            
			if(this.objMaterial.IdMaterial == 0) {
				await this.$http.post(
					'materiales',materialCopy
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'materiales/'+this.objMaterial.IdMaterial,
					materialCopy
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "materiales/"+this.objMaterial.IdMaterial
            ).then((res) => {
                this.objMaterial = res.data.data;
                this.objMaterial.ReqDioptria = this.objMaterial.ReqDioptria== 'SI' ? true : false;
                this.objMaterial.ReqDescuentoDiop = this.objMaterial.ReqDescuentoDiop == 'SI' ? true : false;


            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objMaterial = {
				IdMaterial: 0,
				Nombre: '',
				Clave: '',
				ReqDioptria: false,
                ReqDescuentoDiop: false,
                TipoDescuento: 0,
                ValorDescuento: 0,
				
            }
            this.errorvalidacion = [];
        },
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objMaterial.IdMaterial = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
